export type RouteDefinition = {
  component: string
  path: string
  i18n_paths?: ReadonlyArray<{ [lang: string]: string }>
  as?: string
  name: string
  isCustom?: boolean
}

const routes = {
  home: {
    component: '/',
    path: '/',
    name: 'home',
  },
  page: {
    component: '/[...slug]',
    path: '/:slug+',
    name: 'page',
  },
  articles: {
    component: '/articles/[slug]',
    path: '/articles/:slug',
    name: 'articles',
  },
  talents: {
    component: '/talents/[slug]',
    path: '/talents/:slug',
    name: 'talents',
  },
  engagements: {
    component: '/engagements/[slug]',
    path: '/engagements/:slug+',
    i18n_paths: [
      {
        en: '/commitments/:slug+',
      },
    ],
    name: 'engagements',
  },
  jobs: {
    component: '/metiers/[slug]',
    path: '/metiers/:slug',
    i18n_paths: [
      {
        en: '/professions/:slug',
      },
    ],
    name: 'metiers',
  },
  projects: {
    component: '/projets/[slug]',
    path: '/projets/:slug',
    i18n_paths: [
      {
        en: '/projects/:slug',
      },
    ],
    name: 'projects',
  },
  search: {
    component: '/search/[slug]',
    path: '/search/:slug',
    name: 'search',
  },
  faq: {
    component: '/faq',
    path: '/faq',
    name: 'faq',
  },
  lexicons: {
    component: '/lexique/index',
    path: '/lexique',
    path_en: '/lexicon',
    name: 'lexique',
  },
} as const

export default routes
